import { Bar, BarChart, Cell, LabelList, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

const COLORS = ["#f2d28f", "#d9ad57", "#c79a3f", "#a8813a", "#8f6a2b", "#6f5322", "#55411c"];

export function QuestionInsights({ data }) {
  const rows = data?.rows ?? [];
  const total = rows.reduce((sum, r) => sum + r.count, 0);
  const top = rows.find((r) => r.count > 0);
  return (
    <div className="admin-card p-6 lg:col-span-2" data-testid="question-insights">
      <div className="mb-4 flex flex-wrap items-start justify-between gap-3">
        <div>
          <p className="admin-kicker">Answer insights · what registrants ask about most</p>
          {top ? (
            <p className="mt-1 text-sm text-white/70" data-testid="question-insights-top">
              Top question: <span className="font-semibold text-[#f2d28f]">{top.full}</span> · {Math.round((top.count / Math.max(1, total)) * 100)}% of {total} answers
            </p>
          ) : (
            <p className="mt-1 text-sm text-white/50">No answers yet.</p>
          )}
        </div>
        {data?.skipped > 0 && <span className="text-xs text-white/40">{data.skipped} left blank</span>}
      </div>
      <div className="h-64">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={rows} layout="vertical" margin={{ top: 0, right: 36, left: 8, bottom: 0 }} barCategoryGap={8}>
            <XAxis type="number" hide allowDecimals={false} />
            <YAxis type="category" dataKey="label" width={132} tick={{ fill: "rgba(255,255,255,.72)", fontSize: 12 }} axisLine={false} tickLine={false} />
            <Tooltip cursor={{ fill: "rgba(255,255,255,.05)" }} formatter={(v, _n, p) => [v, p.payload.full]} contentStyle={{ background: "#0b211a", border: "1px solid rgba(255,255,255,.12)", borderRadius: 12, fontSize: 12 }} labelStyle={{ display: "none" }} itemStyle={{ color: "#fff" }} />
            <Bar dataKey="count" name="Registrants" radius={[0, 8, 8, 0]} isAnimationActive>
              {rows.map((row, i) => <Cell key={row.key} fill={COLORS[i % COLORS.length]} />)}
              <LabelList dataKey="count" position="right" fill="rgba(255,255,255,.75)" fontSize={12} fontWeight={700} />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
      {data?.other_answers?.length > 0 && (
        <div className="mt-4 border-t border-white/10 pt-4" data-testid="question-insights-other">
          <p className="mb-2 text-xs font-semibold uppercase tracking-wide text-white/45">"Something else" answers</p>
          <ul className="flex flex-wrap gap-2">
            {data.other_answers.map((a) => (
              <li key={a.text} className="rounded-full border border-white/12 bg-white/5 px-3 py-1 text-xs text-white/80">
                {a.text}{a.count > 1 && <span className="ml-1.5 text-[#f2d28f]">×{a.count}</span>}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
